import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=f07a422c&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=f07a422c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07a422c",
  null
  
)

export default component.exports